// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"f6d6bfaa","56":"08381cf8","311":"06bc7f0c","336":"383cbb92","380":"5df492ae","384":"63c674b2","392":"9988caa9","417":"4aeb9a45","665":"a5a1db28","895":"8a11c476","912":"dc65e777"}[chunkId] + ".chunk.js";
};